import IconWorkoutActive from "../common/images/iconWorkoutActive.png";
import IconUsersActive from "../common/images/iconUsersActive.png";
import IconWorkoutDetailsActive from "../common/images/iconWorkoutDetailsActive.png";
import IconProfileActive from "../common/images/iconProfileActive.png";
import IconExercisesActive from "../common/images/iconExercisesActive.png";

export const AdminTabsList = [
  { icon: IconUsersActive, name: "Users", to: "/private/adminUsers" },
  { icon: IconWorkoutActive, name: "Workouts", to: "/private/adminWorkouts" },
  {
    icon: IconWorkoutDetailsActive,
    name: "Protocols",
    to: "/private/adminProtocols",
  },
  {
    icon: IconExercisesActive,
    name: "Exercises",
    to: "/private/adminExercises",
  },
  {
    icon: IconProfileActive,
    name: "Subscriptions",
    to: "/private/adminSubscriptions",
  },
];
